import { render } from "./TrendingPosts.vue?vue&type=template&id=cdaf96ac"
import script from "./TrendingPosts.vue?vue&type=script&lang=js"
export * from "./TrendingPosts.vue?vue&type=script&lang=js"

import "./TrendingPosts.vue?vue&type=style&index=0&id=cdaf96ac&lang=css"

import exportComponent from "C:\\wamp64\\www\\wordpress\\wp-content\\themes\\yka-theme-2022\\vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__